import { useQuery } from "@tanstack/react-query";
import { API_PLACES } from "../constants";
import { fetcher } from "../utils/fetcher";

export const useFetchPlaces = () => {
  return useQuery({
    queryKey: ["places"],
    queryFn: () => fetcher(API_PLACES),
    select: (response) => {
      const allPlaces = response?.data ?? [];
      const deals = allPlaces.filter((place) => place?.isDeal);
      const nonDeals = allPlaces.filter((place) => !place?.isDeal);

      return {
        places: nonDeals,
        deals,
        all: allPlaces,
      };
    },
    staleTime: 1000 * 60 * 60, // 1 hour
  });
};
